import React from 'react'
import {Scrollbar} from 'react-scrollbars-custom'

export default function G4Scrollbar({sidebar, children, ...props}) {
  if (sidebar) {
    return <Scrollbar {...props}>{children}</Scrollbar>
  }
  return <div>{children}</div>
}
